import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getLocationConfigurationList(params) {
  return request({
    url: URL.mdm.basicData.locationConfiguration,
    method: 'get',
    params
  })
}

export function saveLocationConfiguration(data) {
  return request({
    url: URL.mdm.basicData.locationConfiguration,
    method: data.uuid ? 'put' : 'post',
    data
  })
}
export function releaseStorageLocationFunc(data) {
  return request({
    url: URL.mdm.releaseStorageLocationUrl,
    method: 'post',
    data
  })
}

export function stateCheckFunc(data) {
  return request({
    url: URL.mdm.stateCheckUrl,
    method: 'post',
    data
  })
}

export function checkInventoryFunc(data) {
  return request({
    url: URL.mdm.checkInventoryUrl,
    method: 'post',
    data
  })
}

export function delLocationConfiguration(uuid) {
  return request({
    url: URL.mdm.basicData.locationConfiguration + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
